import { render } from "./DatasetTableOptions.vue?vue&type=template&id=73b20cac"
import script from "./DatasetTableOptions.vue?vue&type=script&lang=js"
export * from "./DatasetTableOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__